export enum RoleType {
  USER = "user",
  ADMIN = "admin",
  GUEST = "guest",
  EMPTY = "",
}

export const RoleTypeLabel = {
  [RoleType.USER]: "Benutzer",
  [RoleType.ADMIN]: "Administrator",
  [RoleType.GUEST]: "Gast",
  [RoleType.GUEST]: "",
};



// WEBPACK FOOTER //
// ./src/types/RoleType.tsx